export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export const TEXT_COLOR_FOCUSED = "#FFF";
export const BACKGROUND_COLOR_FOCUSED = "rgb(53, 175, 254)";

export const secondsToMinutes = (seconds) => {
  var minutes = seconds / 60; 
  return minutes.toFixed();
};
export const MIN_ROW = 10;
